// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__33ymT","ranges":"BmiRanges_ranges__3YbGQ"};